import * as S from './style';

export default function Legends() {
  return (
    <S.Wrapper>
      <S.Legend>평균급여</S.Legend>
    </S.Wrapper>
  );
}
